import { connect } from "react-redux";

import {
  selectMaterialById,
  updateMaterial,
  removeMaterial
} from "~/store/ducks/application/materials/materials";

import { selectIsGreaterThanMedium } from "~/store/ducks/application/browser";

import { switchModal } from "~/store/ducks/domain/ui/modal";

import EditMaterialModal from "./EditMaterialModal";

const mapStateToProps = (state, ownProps) => ({
  material: selectMaterialById(ownProps.id)(state),
  isGreaterThanMedium: selectIsGreaterThanMedium(state)
});

const mapDispatchToProps = {
  switchModal,
  updateMaterial,
  removeMaterial
};

export default connect(mapStateToProps, mapDispatchToProps)(EditMaterialModal);
